var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReceivedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-receive"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M15.314-12a.676.676,0,0,1,.686.667h0v8.711A2.569,2.569,0,0,1,13.486,0H2.514A2.569,2.569,0,0,1,0-2.622H0v-8.711A.676.676,0,0,1,.686-12a.676.676,0,0,1,.686.667h0v8.711A1.224,1.224,0,0,0,2.514-1.333H13.486a1.224,1.224,0,0,0,1.143-1.289h0v-8.711A.676.676,0,0,1,15.314-12ZM8-16l.117,0c.381.031.673.209.673.424h0v7.132l2.863-2.59.1-.075a.853.853,0,0,1,1.019.075.667.667,0,0,1,0,1.01h0L8.558-6.209l-.1.075a.853.853,0,0,1-1.019-.075h0l-4.211-3.81-.076-.08a.665.665,0,0,1,.076-.93h0l.1-.075a.853.853,0,0,1,1.019.075h0L7.21-8.44v-7.131l.009-.063C7.275-15.841,7.6-16,8-16Z",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(0 16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    clipPath: "url(#clip-path-receive)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M-5-21H21V5H-5Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceivedIcon);
export default __webpack_public_path__ + "static/media/received-icon.12b0743c2fa332ba8290fd75078d4b61.svg";
export { ForwardRef as ReactComponent };